export default __webpack_public_path__ + "static/media/Toyoda.31c479a7.png";